import { createFileRoute } from '@tanstack/react-router'

import { EndorsementStepPageIndex } from '../../../../../../../components/pages/subscription-v2/endorsement-step-page-index.tsx'

export const Route = createFileRoute('/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/$stepId/')({
  component: EndorsementStepPage,
})

function EndorsementStepPage() {
  const { subscriptionId, endorsementId, stepId } = Route.useParams()

  return <EndorsementStepPageIndex subscriptionId={subscriptionId} endorsementId={endorsementId} stepId={stepId} />
}
